import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import Navigation from './Navigation'
import TopNav from './TopNav'
import MobileNav from './MobileNav'

function AuthRoutes({ auth, children }) {
  if (!auth.isAuthorized) {
    return <Redirect to='/login' />
  }

  return (
    <>
      <header>
        <TopNav />
        <MobileNav />
      </header>
      <div className='wrapper'>
        <Navigation />
        <section id='main-wrapper' className='container-fluid me-0'>
          <div> {children}</div>
        </section>
      </div>
    </>
  )
}

const mapStateToProps = ({ auth }) => ({ auth })

export default connect(mapStateToProps)(AuthRoutes)
